import { render, staticRenderFns } from "./TotalDebt.vue?vue&type=template&id=5174297e&scoped=true&"
import script from "./TotalDebt.vue?vue&type=script&lang=js&"
export * from "./TotalDebt.vue?vue&type=script&lang=js&"
import style0 from "./TotalDebt.vue?vue&type=style&index=0&id=5174297e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5174297e",
  null
  
)

export default component.exports